import { render, staticRenderFns } from "./createMfFuwuOrder.vue?vue&type=template&id=6f9dbb4a&scoped=true"
import script from "./createMfFuwuOrder.vue?vue&type=script&lang=js"
export * from "./createMfFuwuOrder.vue?vue&type=script&lang=js"
import style0 from "./createMfFuwuOrder.vue?vue&type=style&index=0&id=6f9dbb4a&prod&scoped=true&lang=css"
import style1 from "./createMfFuwuOrder.vue?vue&type=style&index=1&id=6f9dbb4a&prod&lang=css"
import style2 from "./createMfFuwuOrder.vue?vue&type=style&index=2&id=6f9dbb4a&prod&scoped=true&lang=scss"
import style3 from "./createMfFuwuOrder.vue?vue&type=style&index=3&id=6f9dbb4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9dbb4a",
  null
  
)

export default component.exports